module.exports = __webpack_public_path__ + "static/sre-fc94074425df3bf1dba00620694de131.png";